import {
   EQ_EXERCISE_TYPE,
   INTERVAL_EXERCISE_TYPE,
   MIXER_EXERCISE_TYPE,
   TRANSCRIPTION_EXERCISE_TYPE,
} from './exerciseTypes';
import { calculateTranscriptionScore } from './transcription/calculateTranscriptionScore';
import { caculateMixerScore } from './mixer/caculateMixerScore';

const { calculateIntervalScore } = require('./interval/util');

export const calculateScore = (exerciseType, activeInterface) => {
   switch (exerciseType) {
      case INTERVAL_EXERCISE_TYPE:
         return calculateIntervalScore(activeInterface);
      case TRANSCRIPTION_EXERCISE_TYPE:
         return calculateTranscriptionScore(activeInterface);
      case MIXER_EXERCISE_TYPE:
         return caculateMixerScore(activeInterface);
      default:
         return null;
   }
};
